export enum COBannerVariant {
  Info = 'info',
  Warning = 'warning',
  Error = 'error',
  Success = 'success',
}